import { Fragment, PureComponent } from 'react';
import cns from 'classnames';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';

import { DistanceGroupField } from 'components/forms/filters/Location/Distance';
import { GeoLocationGroupField } from 'components/forms/filters/Location/GeoLocation';
import cn from './styles.local.less';

export default class LocationItem extends PureComponent {
  renderControlLabel({ className, ...props }) {
    return <ControlLabel className={cns(className, cn.label)} {...props} />;
  }

  render() {
    const props = {
      ...this.props,
      ControlLabel: this.renderControlLabel,
      className: cn.field,
    };

    return (
      <Fragment>
        <GeoLocationGroupField {...props} />
        <DistanceGroupField {...props} />
      </Fragment>
    );
  }
}
